module.exports = __webpack_public_path__ + "1866586b05e3edb2a9ca227f83fe0f9a.glb";